import { AssistantCompleteModel } from '../../features/marketplace/types';

export const getAssistantChapterNames = (
  assistant: AssistantCompleteModel | null | undefined
): string[] => {
  if (!assistant) {
    return [];
  }

  // Prefer new knowledges structure; fall back to legacy knowledgeBases
  if (assistant.knowledges && assistant.knowledges.length > 0) {
    return (assistant.knowledges ?? []).flatMap((knowledge) =>
      (knowledge.chapters ?? []).map((chapter) => chapter.name)
    );
  }

  // Fall back to legacy knowledgeBases structure for unmigrated assistants
  return (assistant.knowledgeBases ?? []).flatMap(
    (knowledgeBase) =>
      knowledgeBase.indexes?.flatMap(
        (index) => index.chapters?.map((chapter) => chapter.name) ?? []
      ) ?? []
  );
};

export const normalizeChapterSearchParam = (
  chapter: string | string[] | undefined
): string[] => {
  if (!chapter) {
    return [];
  }

  const values = Array.isArray(chapter) ? chapter : [chapter];
  return [...new Set(values.map((v) => v.trim()).filter(Boolean))];
};

export const filterAssistantChapterNames = (
  assistant: AssistantCompleteModel | null | undefined,
  selectedChapters: string[]
): string[] => {
  const availableChapterNames = new Set(getAssistantChapterNames(assistant));

  return selectedChapters.filter((chapter) =>
    availableChapterNames.has(chapter)
  );
};

export const buildAssistantChatUrl = (
  origin: string,
  assistantIdentifier: string,
  selectedChapters: string[] = []
): string => {
  const searchParams = new URLSearchParams({ assistant: assistantIdentifier });
  const normalizedChapters = selectedChapters.filter(
    (chapter) => chapter.trim() !== '' && chapter.trim() !== '[]'
  );

  for (const chapter of normalizedChapters) {
    searchParams.append('chapter', chapter);
  }

  return `${origin}/chat?${searchParams.toString()}`;
};
